(function(){
    'use strict'; 

    angular.module('Directives').directive('shortenText', shortenText);

    shortenText.$inject = ['$uibModal'];
    
    function shortenText($uibModal) {
        return {
            restrict: 'A',
            scope: {
                text: '@',
                limit: '@',
                showFullDetails: '=?'
            },
            template:`<span style="word-wrap: break-word">
                <a ng-if="isModalEnabled" ng-click="showWholeText()" style="cursor:pointer;">{{truncatedText}}</a> 
                <span ng-if="!isModalEnabled">{{truncatedText}}</span>
            </span>`,
            link: shortenTextLink
        }

        function shortenTextLink($scope) {
            $scope.showWholeText = showWholeText;

            init(); 

            function init() {
                $scope.$watch('text', (text) => {
                    $scope.truncatedText = truncate(text, $scope.limit);
                });
            }

            function truncate(text, limit) {
                if (!text) { return null; }

                if (text.length > $scope.limit) {
                    $scope.isModalEnabled = $scope.showFullDetails;
                    return `${text.substring(0, limit)}...`;
                }

                $scope.isModalEnabled = false;
                return text;
            }

            function showWholeText() {
                $uibModal.open({
                    animation: true, 
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    template: `
                        <div class="modal-header">
                            <a href="" ng-click="vm.close()" class="float-right btn-close"><i class="fa fa-remove"></i></a>
                            <h4 class="modal-title"><b>See full details below.</b></h4>
                        </div>
                        <div class="modal-body" style="padding: 10px !important;">
                            <div class="row">
                                <div class="col-md-12">
                                    <div style="word-wrap: break-word; background: #d1d1d1; padding: 10px; font-weight: bold;">
                                        {{vm.text}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    `,
                    controller: function ($uibModalInstance, text) {
                        const vm = this; 

                        vm.close = close;

                        init(); 

                        function init() {
                            vm.text = text;
                        }

                        function close() {
                            $uibModalInstance.close();
                        }
                    },
                    controllerAs: 'vm',
                    size: 'sm',
                    appendTo: $('body'),
                    backdrop: 'static',
                    resolve: {
                        text: () => {
                            return $scope.text;
                        }
                    }
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/shortenText.js